document.addEventListener("DOMContentLoaded", function () {

  // 🔥 Bandera GLOBAL para toda la página
  let userSelectedFrequency = false;

  function setupSeal() {
    const addToCartBtn = document.querySelector('button[type="submit"][name="add"]');
    const select = document.querySelector('.sls-select[name="subs_interval"]');
    if (!select || !addToCartBtn) return;

    /* 1. Insertar placeholder con value="0" */
    let placeholder = select.querySelector('option[data-placeholder="true"]');
    if (!placeholder) {
      placeholder = document.createElement("option");
      placeholder.value = "0";
      placeholder.textContent = "Choose a frequency";
      placeholder.setAttribute("data-placeholder", "true");
      select.insertBefore(placeholder, select.firstChild);
    }

    /* 2. Forzar placeholder SOLO si el usuario aún no ha elegido nada */
    function forcePlaceholderIfNeeded() {
      if (!userSelectedFrequency) {
        select.value = "0";
        select.dispatchEvent(new Event("change"));
      }
    }

    /* 3. Detectar modo REAL por selling_plan.value */
    function getMode() {
      const sp = document.querySelector('input[name="selling_plan"]');
      if (!sp) return "one-time";          // No existe → modo compra normal
      if (sp.value === "") return "one-time"; // Existe pero value vacío → compra normal
      return "subscribe";                  // Tiene número → suscripción
    }

    /* 4. Validar frecuencia */
    function isValidFreq() {
      return select.value !== "0";
    }

    /* 5. Actualizar botón */
    function updateBtn() {
      // Never re-enable a sold-out button: the product page marks it with
      // aria-disabled="true" (Liquid render and setVariant both do). The
      // Klaviyo "Notify me" swap depends on the button STAYING disabled.
      if (addToCartBtn.getAttribute("aria-disabled") === "true") {
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = "";
        addToCartBtn.style.cursor = "";
        return;
      }

      const mode = getMode();

      if (mode === "one-time") {
        addToCartBtn.disabled = false;
        addToCartBtn.style.opacity = "";
        addToCartBtn.style.cursor = "";
        return;
      }

      if (!isValidFreq()) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = "0.5";
        addToCartBtn.style.cursor = "not-allowed";
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.style.opacity = "";
        addToCartBtn.style.cursor = "";
      }
    }

    /* 6. Escuchar clicks en radios (one-time / subscribe) */
    document.querySelectorAll('[role="radio"]').forEach(radio => {
      radio.addEventListener("click", function () {
        setTimeout(() => {
          const mode = getMode();

          if (mode === "subscribe") {
            // Entramos a suscripción → placeholder por defecto SOLO si el usuario aún no ha elegido
            forcePlaceholderIfNeeded();
          } else {
            // Volvimos a one-time → reseteamos la bandera
            userSelectedFrequency = false;
          }

          updateBtn();
        }, 30);
      });
    });

    /* 7. Cambio del select */
    select.addEventListener("change", function () {
      if (select.value !== "0") {
        // El usuario ya eligió una frecuencia válida
        userSelectedFrequency = true;
      }
      updateBtn();
    });

    /* 8. Bloquear Add to Cart si está en suscripción sin frecuencia */
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      form.addEventListener("submit", function (e) {
        if (getMode() === "subscribe" && !isValidFreq()) {
          e.preventDefault();
          alert("Please choose a delivery frequency before adding to cart.");
        }
      });
    }

    /* 9. Observer para cambios en selling_plan (modo cambia) */
    const spObserver = new MutationObserver(() => {
      const mode = getMode();

      if (mode === "subscribe") {
        // Seal entra o re-renderiza suscripción:
        // Forzamos placeholder solo si el usuario no eligió frecuencia aún
        forcePlaceholderIfNeeded();
      } else {
        // Modo one-time → reset de bandera
        userSelectedFrequency = false;
      }

      updateBtn();
    });

    const watchArea = document.querySelector('.sls-purchase-options-container') || document.body;
    spObserver.observe(watchArea, { childList: true, subtree: true });

    updateBtn();
  }

  /* 10. Seal re-renderiza → volver a enganchar lógica */
  const observer = new MutationObserver(setupSeal);
  observer.observe(document.body, { childList: true, subtree: true });

  setupSeal();
});
